import { render } from "./GoalPage.vue?vue&type=template&id=57ba69dd"
import script from "./GoalPage.vue?vue&type=script&lang=js"
export * from "./GoalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__